import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { RemissionDetailTableModel } from 'src/app/models/tables/rental/remission-detail-table.model';
import { environment } from 'src/environments/environment';
import { RemissionDetailModel } from './../../models/rental/remission-detail';
import { RemissionModel } from './../../models/rental/remission.model';
import { RentalStockModel } from './../../models/rental/rental-stock-response.model';
import { RemissionDetailRegisterModel } from 'src/app/models/tables/rental/remission-detail-register.model';

@Injectable({
  providedIn: 'root'
})
export class RemissionDetailService {

  constructor(private _httpClient: HttpClient) { }


  exportDetailConsultation(filters: ColumnResponseModel[], columnSort: string | null, ascendant: boolean): Observable<Blob> {
    const params = new HttpParams().set('columnSort', columnSort ?? '').set('ascendant', ascendant.toString());
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.remissionDetail.ExportDetailConsultation}`, filters, {
      params, responseType: 'blob',
    });
  }

  getColumnsForDetailConsultation(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.remissionDetail.GetColumnsForDetailConsultation}`);
  }

  getColumnsForCaptureTable(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.remissionDetail.GetColumnsForCaptureTable}`,);
  }

  getColumnsForListStocksInShop(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.remissionDetail.GetColumnsForListStocksInShop}`);
  }

  getRemissionDetailById(remissionDetailId: number): Observable<RemissionDetailModel> {
    return this._httpClient.get<RemissionDetailModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.remissionDetail.GetRemissionDetailById}/${remissionDetailId}`);
  }

  createRemissionDetail(remissionDetailContract: RemissionDetailModel): Observable<RemissionDetailModel> {
    return this._httpClient.post<RemissionDetailModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.remissionDetail.CreateRemissionDetail}`,
      remissionDetailContract);
  }

  createRemissionDetails(remissionDetails: RemissionDetailModel[], remissionDetailId: number): Observable<boolean> {
    return this._httpClient.post<boolean>(`${environment.apiCervinoBackend}${enpointCervinoWeb.remissionDetail.CreateDetails}/${remissionDetailId}`,
      remissionDetails
    );
  }

  updateRemissionDetail(remissionDetailContract: RemissionDetailModel): Observable<RemissionDetailModel> {
    return this._httpClient.put<RemissionDetailModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.remissionDetail.UpdateRemissionDetail}`,
      remissionDetailContract
    );
  }

  updateRemissionByHoursDays(remissionDetailContract: RemissionDetailModel): Observable<RemissionDetailModel> {
    return this._httpClient.put<RemissionDetailModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.remissionDetail.UpdateRemissionByHoursDaysAsync}`,
      remissionDetailContract
    );
  }

  deleteSomeDetails(remissionDetailIds: Array<number>): Observable<boolean> {
    return this._httpClient.put<boolean>(`${environment.apiCervinoBackend}${enpointCervinoWeb.remissionDetail.DeleteSomeDetails}`,
      remissionDetailIds
    );
  }

  getRemissionDetailByRemissionId(remissionId: number): Observable<Array<RemissionDetailModel>> {
    return this._httpClient.get<Array<RemissionDetailModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.remissionDetail.GetRemissionDetailsByRemissionId}/${remissionId}`);
  }

  getRemissionDetailsBySwIncludeStore(remissionId: number, swIncludeStore: boolean): Observable<Array<RemissionDetailModel>> {
    return this._httpClient.get<Array<RemissionDetailModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.remissionDetail.GetRemissionDetailsBySwIncludeStore}/${remissionId}/${swIncludeStore}`);
  }

  getRemissionDetailByKeys(remissionId: number, storeId: number, articleId: number): Observable<RemissionDetailModel> {
    const params = new HttpParams().set('remissionId', remissionId).set('storeId', storeId).set('articleId', articleId);
    return this._httpClient.get<RemissionDetailModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.remissionDetail.GetRemissionDetailByKeys}`,
      { params: params }
    );
  }

  getAllRemissionDetailsWithPagination(page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<RemissionDetailTableModel>> {
    const params = new HttpParams().set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant);
    return this._httpClient.post<PagedResponseModel<RemissionDetailTableModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.remissionDetail.GetAllRemissionDetailsWithPagination}`,
      filters, { params: params }
    );
  }

  getStocksByArticleIdStoreId(rentalStockModel: RentalStockModel): Observable<RentalStockModel> {
    return this._httpClient.post<RentalStockModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.remissionDetail.GetStocksByArticleIdStoreId}`,
      rentalStockModel
    );
  }

  getRemissionDetailsForCaptureTable(page: number, limit: number, columnSort: string | null, ascendant: boolean, remissionId: number): Observable<PagedResponseModel<RemissionDetailRegisterModel>> {
    const params = new HttpParams().set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant).set('remissionId', remissionId);
    return this._httpClient.get<PagedResponseModel<RemissionDetailRegisterModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.remissionDetail.GetRemissionDetailsForCaptureTable}`,
      { params: params }
    );
  }

  getListStocksInShop(rentalStockContract: RemissionModel): Observable<Array<RentalStockModel>> {
    return this._httpClient.post<Array<RentalStockModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.remissionDetail.GetListStocksInShop}`,
      rentalStockContract
    );
  }

  getListArticlesStocksInShop(remissionId: number, page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<RentalStockModel>> {
    const params = new HttpParams().set('remissionId', remissionId).set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant);
    return this._httpClient.post<PagedResponseModel<RentalStockModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.remissionDetail.GetListStocksInShop}`,
      filters, { params: params }
    );
  }

  getQuantityDetail(remissionId: number): Observable<number> {
    return this._httpClient.get<number>(`${environment.apiCervinoBackend}${enpointCervinoWeb.remissionDetail.GetQuantityDetail}/${remissionId}`);
  }
}
